import { Form } from 'antd';
import styled from 'styled-components';

export const SubjectsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.red7};
  margin-top: 16px;
`;

export const CenterFormItem = styled(Form.Item)`
  display: flex;
  align-items: center;
  flex: 0 0 90px;

  .ant-input {
    width: 90px;
    text-align: center;
  }
`;

export const CourseName = styled.span`
  flex: 1;
  min-width: 0;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
